var B = /* @__PURE__ */ ((e) => (e.email = "email", e.profile = "profile", e.openid = "openid", e.offline_access = "offline", e))(B || {}), D = /* @__PURE__ */ ((e) => (e.none = "none", e.create = "create", e.login = "login", e))(D || {}), M = /* @__PURE__ */ ((e) => (e.organizationDetails = "organization_details", e.organizationMembers = "organization_members", e.organizationPlanDetails = "organization_plan_details", e.organizationPaymentDetails = "organization_payment_details", e.organizationPlanSelection = "organization_plan_selection", e.profile = "profile", e))(M || {}), H = /* @__PURE__ */ ((e) => (e.organizationDetails = "organization_details", e.organizationMembers = "organization_members", e.organizationPlanDetails = "organization_plan_details", e.organizationPaymentDetails = "organization_payment_details", e.organizationPlanSelection = "organization_plan_selection", e.profile = "profile", e))(H || {}), I = /* @__PURE__ */ ((e) => (e.logout = "logout", e.login = "login", e.register = "registration", e.token = "token", e.profile = "profile", e))(I || {}), w = /* @__PURE__ */ ((e) => (e[e.refreshToken = 0] = "refreshToken", e[e.cookie = 1] = "cookie", e))(w || {});
const L = (e) => {
  const r = (c) => btoa(c).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
  if (e instanceof ArrayBuffer) {
    const c = new Uint8Array(e), s = String.fromCharCode(...c);
    return r(s);
  }
  const n = new TextEncoder().encode(e), o = String.fromCharCode(...n);
  return r(o);
}, C = (e = 28) => {
  if (crypto) {
    const r = new Uint8Array(e / 2);
    return crypto.getRandomValues(r), Array.from(r, G).join("");
  } else
    return J(e);
};
function G(e) {
  return e.toString(16).padStart(2, "0");
}
function J(e = 28) {
  const r = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let t = "";
  const n = r.length;
  for (let o = 0; o < e; o++)
    t += r.charAt(Math.floor(Math.random() * n));
  return t;
}
const ae = (e) => {
  e = e.split("?")[1];
  const r = new URLSearchParams(e);
  return {
    accessToken: r.get("access_token"),
    idToken: r.get("id_token"),
    expiresIn: +(r.get("expires_in") || 0)
  };
}, b = (e) => e.replace(/\/$/, ""), W = (e, r = !1) => {
  const t = Array.isArray(e.audience) ? e.audience.join(" ") : e.audience || "", n = {
    login_hint: e.loginHint,
    is_create_org: e.isCreateOrg?.toString(),
    connection_id: e.connectionId,
    redirect_uri: e.redirectURL ? r ? e.redirectURL : b(e.redirectURL) : void 0,
    audience: t,
    scope: e.scope?.join(" ") || "email profile openid offline",
    prompt: e.prompt,
    lang: e.lang,
    org_code: e.orgCode,
    org_name: e.orgName,
    has_success_page: e.hasSuccessPage?.toString(),
    workflow_deployment_id: e.workflowDeploymentId,
    supports_reauth: e.supportsReauth?.toString(),
    plan_interest: e.planInterest,
    pricing_table_key: e.pricingTableKey,
    pages_mode: e.pagesMode
  };
  return Object.keys(n).forEach(
    (o) => n[o] === void 0 && delete n[o]
  ), n;
}, U = (e) => typeof e != "object" || e === null ? e : Array.isArray(e) ? e.map((r) => U(r)) : Object.fromEntries(
  Object.entries(e).map(([r, t]) => [
    r.replace(/_([a-z])/g, (n, o) => o.toUpperCase()),
    U(t)
  ])
), Z = [
  // UTM tags
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term",
  // Google Ads smart campaign tracking
  "gclid",
  "click_id",
  "hsa_acc",
  "hsa_cam",
  "hsa_grp",
  "hsa_ad",
  "hsa_src",
  "hsa_tgt",
  "hsa_kw",
  "hsa_mt",
  "hsa_net",
  "hsa_ver",
  // Marketing category
  "match_type",
  "keyword",
  "device",
  "ad_group_id",
  "campaign_id",
  "creative",
  "network",
  "ad_position",
  "fbclid",
  "li_fat_id",
  "msclkid",
  "twclid",
  "ttclid"
], ie = async (e, r = I.login, t, n) => {
  const o = `${e}/oauth2/auth`, c = T();
  if (t.reauthState)
    try {
      const u = U(
        JSON.parse(atob(t.reauthState))
      );
      t = {
        ...t,
        ...u
      }, delete t.reauthState;
    } catch (u) {
      const h = u instanceof Error ? u.message : "Unknown error";
      throw new Error(`Error handing reauth state: ${h}`);
    }
  if (!t.clientId)
    throw new Error("Error generating auth URL: Client ID missing");
  const s = {
    client_id: t.clientId,
    response_type: t.responseType || "code",
    ...W(t, n?.disableUrlSanitization)
  };
  t.state || (t.state = C(32)), c && c.setSessionItem(a.state, t.state), s.state = t.state, t.nonce || (t.nonce = C(16)), s.nonce = t.nonce, c && c.setSessionItem(a.nonce, t.nonce);
  let d = "";
  if (t.codeChallenge)
    s.code_challenge = t.codeChallenge;
  else {
    const { codeVerifier: u, codeChallenge: h } = await Q();
    d = u, c && c.setSessionItem(a.codeVerifier, u), s.code_challenge = h;
  }
  s.code_challenge_method = "S256", t.codeChallengeMethod && (s.code_challenge_method = t.codeChallengeMethod), !t.prompt && r === I.register && (s.prompt = D.create), t.properties && Object.keys(t.properties).forEach((u) => {
    if (!Z.includes(u)) {
      console.warn("Unsupported Property for url generation: ", u);
      return;
    }
    const h = t.properties?.[u];
    h !== void 0 && (s[u] = h);
  });
  const l = new URLSearchParams(s).toString();
  return {
    url: new URL(`${o}?${l}`),
    state: s.state,
    nonce: s.nonce,
    codeChallenge: s.code_challenge,
    codeVerifier: d
  };
};
async function Q() {
  const e = C(52), r = new TextEncoder().encode(e);
  let t = "";
  if (!crypto)
    t = L(btoa(e));
  else {
    const n = await crypto.subtle.digest("SHA-256", r);
    t = L(n);
  }
  return { codeVerifier: e, codeChallenge: t };
}
let y;
function V(e, r) {
  if (P(), typeof window > "u")
    throw new Error("setRefreshTimer requires a browser environment");
  if (e <= 0)
    throw new Error("Timer duration must be positive");
  y = window.setTimeout(
    r,
    Math.min(e * 1e3 - 1e4, 864e5)
  );
}
function P() {
  y !== void 0 && (window.clearTimeout(y), y = void 0);
}
const p = {
  framework: "",
  frameworkVersion: "",
  sdkVersion: ""
}, N = async () => {
  await T()?.removeItems(
    a.state,
    a.nonce,
    a.codeVerifier
  );
}, X = () => `${p.framework}/${p.sdkVersion}/${p.frameworkVersion}/Javascript`, ce = async ({
  urlParams: e,
  domain: r,
  clientId: t,
  redirectURL: n,
  autoRefresh: o = !1,
  onRefresh: c
}) => {
  const s = e.get("state"), d = e.get("code");
  if (!s || !d)
    return console.error("Invalid state or code"), {
      success: !1,
      error: "Invalid state or code"
    };
  const l = T();
  if (!l)
    return console.error("No active storage found"), {
      success: !1,
      error: "Authentication storage is not initialized"
    };
  (!p.framework || !p.frameworkVersion) && console.warn(
    "Framework and version not set. Please set the framework and version in the config object"
  );
  const u = await l.getSessionItem(a.state);
  if (s !== u)
    return console.error("Invalid state"), {
      success: !1,
      error: `Invalid state; supplied ${s}, expected ${u}`
    };
  const h = await l.getSessionItem(
    a.codeVerifier
  );
  if (h === null)
    return console.error("Code verifier not found"), {
      success: !1,
      error: "Code verifier not found"
    };
  const R = {
    "Content-type": "application/x-www-form-urlencoded; charset=UTF-8"
  };
  p.framework && (R["Kinde-SDK"] = X());
  const j = {
    method: "POST",
    ...!i.useInsecureForRefreshToken && v(r) ? {
      credentials: "include"
    } : {},
    headers: new Headers(R),
    body: new URLSearchParams({
      client_id: t,
      code: d,
      code_verifier: h,
      grant_type: "authorization_code",
      redirect_uri: n
    })
  };
  let S;
  P();
  try {
    if (S = await fetch(`${r}/oauth2/token`, j), !S?.ok) {
      const m = await S.text();
      return console.error("Token exchange failed:", S.status, m), {
        success: !1,
        error: `Token exchange failed: ${S.status} - ${m}`
      };
    }
  } catch (m) {
    return N(), console.error("Token exchange failed:", m), {
      success: !1,
      error: `Token exchange failed: ${m}`
    };
  }
  const f = await S.json(), z = _();
  z && z.setItems({
    [a.accessToken]: f.access_token,
    [a.idToken]: f.id_token,
    [a.refreshToken]: f.refresh_token
  }), (i.useInsecureForRefreshToken || !v(r)) && l.setSessionItem(a.refreshToken, f.refresh_token), o && V(f.expires_in, async () => {
    $({ domain: r, clientId: t, onRefresh: c });
  }), N();
  const q = ((m) => (m.search = "", m))(new URL(window.location.toString()));
  return window.history.replaceState(window.history.state, "", q), !f.access_token || !f.id_token || !f.refresh_token ? {
    success: !1,
    error: "No access token received"
  } : {
    success: !0,
    [a.accessToken]: f.access_token,
    [a.idToken]: f.id_token,
    [a.refreshToken]: f.refresh_token
  };
};
function Y(e) {
  const t = document.cookie.split("; ").find((n) => n.startsWith(`${e}=`));
  if (!t) return null;
  try {
    const n = t.split("=")[1];
    return n ? decodeURIComponent(n) : null;
  } catch (n) {
    return console.error(`Error parsing cookie ${e}:`, n), null;
  }
}
const O = "_kbrte", le = async ({
  domain: e,
  clientId: r
}) => {
  if (!e)
    return {
      success: !1,
      error: "Domain is required for authentication check"
    };
  if (!r)
    return {
      success: !1,
      error: "Client ID is required for authentication check"
    };
  const t = v(e), n = i.useInsecureForRefreshToken;
  let o = null;
  return t && !n && (o = Y(O)), await $({
    domain: e,
    clientId: r,
    refreshType: o ? w.cookie : w.refreshToken
  });
}, v = (e) => !e.match(
  /^(?:https?:\/\/)?[a-zA-Z0-9][.-a-zA-Z0-9]*\.kinde\.com$/i
);
function A(e, r) {
  return r <= 0 ? [] : e.match(new RegExp(`.{1,${r}}`, "g")) || [];
}
var a = /* @__PURE__ */ ((e) => (e.accessToken = "accessToken", e.idToken = "idToken", e.refreshToken = "refreshToken", e.state = "state", e.nonce = "nonce", e.codeVerifier = "codeVerifier", e))(a || {});
class E {
  async setItems(r) {
    await Promise.all(
      Object.entries(r).map(
        ([t, n]) => this.setSessionItem(t, n)
      )
    );
  }
  async removeItems(...r) {
    await Promise.all(
      r.map((t) => this.removeSessionItem(t))
    );
  }
}
class ue extends E {
  memCache = {};
  /**
   * Clears all items from session store.
   * @returns {void}
   */
  async destroySession() {
    this.memCache = {};
  }
  /**
   * Sets the provided key-value store to the memory cache.
   * @param {string} itemKey
   * @param {unknown} itemValue
   * @returns {void}
   */
  async setSessionItem(r, t) {
    if (await this.removeSessionItem(r), typeof t == "string") {
      A(t, i.maxLength).forEach(
        (n, o) => {
          this.memCache[`${i.keyPrefix}${r}${o}`] = n;
        }
      );
      return;
    }
    this.memCache[`${i.keyPrefix}${String(r)}0`] = t;
  }
  /**
   * Gets the item for the provided key from the memory cache.
   * @param {string} itemKey
   * @returns {unknown | null}
   */
  async getSessionItem(r) {
    if (this.memCache[`${i.keyPrefix}${String(r)}0`] === void 0)
      return null;
    let t = "", n = 0, o = `${i.keyPrefix}${String(r)}${n}`;
    for (; this.memCache[o] !== void 0; )
      t += this.memCache[o], n++, o = `${i.keyPrefix}${String(r)}${n}`;
    return t;
  }
  /**
   * Removes the item for the provided key from the memory cache.
   * @param {string} itemKey
   * @returns {void}
   */
  async removeSessionItem(r) {
    for (const t in this.memCache)
      t.startsWith(`${i.keyPrefix}${String(r)}`) && delete this.memCache[t];
  }
}
function x(e) {
  return new Promise((r, t) => {
    chrome.storage.local.get([e], function(n) {
      chrome.runtime.lastError ? t(void 0) : r(n[e]);
    });
  });
}
class de extends E {
  /**
   * Clears all items from session store.
   * @returns {void}
   */
  async destroySession() {
    await chrome.storage.local.clear();
  }
  /**
   * Sets the provided key-value store to the chrome.store.local.
   * @param {string} itemKey
   * @param {unknown} itemValue
   * @returns {void}
   */
  async setSessionItem(r, t) {
    if (await this.removeSessionItem(r), typeof t == "string") {
      A(t, i.maxLength).forEach(
        async (n, o) => {
          await chrome.storage.local.set({
            [`${i.keyPrefix}${r}${o}`]: n
          });
        }
      );
      return;
    }
    await chrome.storage.local.set({
      [`${i.keyPrefix}${r}0`]: t
    });
  }
  /**
   * Gets the item for the provided key from the chrome.store.local cache.
   * @param {string} itemKey
   * @returns {unknown | null}
   */
  async getSessionItem(r) {
    let t = "", n = 0, o = `${i.keyPrefix}${String(r)}${n}`;
    for (; await x(
      `${i.keyPrefix}${String(r)}${n}`
    ) !== void 0; )
      t += await x(o), n++, o = `${i.keyPrefix}${String(r)}${n}`;
    return t;
  }
  /**
   * Removes the item for the provided key from the chrome.store.local cache.
   * @param {string} itemKey
   * @returns {void}
   */
  async removeSessionItem(r) {
    let t = 0;
    for (; await x(
      `${i.keyPrefix}${String(r)}${t}`
    ) !== void 0; )
      await chrome.storage.local.remove(
        `${i.keyPrefix}${String(r)}${t}`
      ), t++;
  }
}
class fe extends E {
  constructor() {
    super(), i.useInsecureForRefreshToken && console.warn("LocalStorage store should not be used in production");
  }
  internalItems = /* @__PURE__ */ new Set();
  /**
   * Clears all items from session store.
   * @returns {void}
   */
  async destroySession() {
    this.internalItems.forEach((r) => {
      this.removeSessionItem(r);
    });
  }
  /**
   * Sets the provided key-value store to the localStorage cache.
   * @param {V} itemKey
   * @param {unknown} itemValue
   * @returns {void}
   */
  async setSessionItem(r, t) {
    if (await this.removeSessionItem(r), this.internalItems.add(r), typeof t == "string") {
      A(t, i.maxLength).forEach(
        (n, o) => {
          localStorage.setItem(
            `${i.keyPrefix}${r}${o}`,
            n
          );
        }
      );
      return;
    }
    localStorage.setItem(
      `${i.keyPrefix}${r}0`,
      t
    );
  }
  /**
   * Gets the item for the provided key from the localStorage cache.
   * @param {string} itemKey
   * @returns {unknown | null}
   */
  async getSessionItem(r) {
    if (localStorage.getItem(`${i.keyPrefix}${r}0`) === null)
      return null;
    let t = "", n = 0, o = `${i.keyPrefix}${String(r)}${n}`;
    for (; localStorage.getItem(o) !== null; )
      t += localStorage.getItem(o), n++, o = `${i.keyPrefix}${String(r)}${n}`;
    return t;
  }
  /**
   * Removes the item for the provided key from the localStorage cache.
   * @param {V} itemKey
   * @returns {void}
   */
  async removeSessionItem(r) {
    let t = 0;
    for (; localStorage.getItem(
      `${i.keyPrefix}${String(r)}${t}`
    ) !== null; )
      localStorage.removeItem(
        `${i.keyPrefix}${String(r)}${t}`
      ), t++;
    this.internalItems.delete(r);
  }
}
const i = {
  /**
   * The prefix to use for the storage keys.
   */
  keyPrefix: "kinde-",
  /**
   * The maximum length of the storage.
   *
   * If the length is exceeded the items will be split into multiple storage items.
   */
  maxLength: 2e3,
  /**
   * Use insecure storage for refresh token.
   *
   * Warning: This should only be used when you're not using a custom domain and no backend app to authenticate on.
   */
  useInsecureForRefreshToken: !1
};
function K(e, r) {
  if (!e)
    return null;
  const t = e.split(".");
  if (t.length !== 3)
    return null;
  const n = t[
    1
    /* body */
  ].replace(/-/g, "+").replace(/_/g, "/"), o = decodeURIComponent(
    atob(n).split("").map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2)).join("")
  );
  return JSON.parse(o);
}
const k = async (e = a.accessToken) => {
  const r = _();
  if (!r)
    return null;
  const t = await r.getSessionItem(
    e === "accessToken" ? a.accessToken : a.idToken
  );
  if (!t)
    return null;
  const n = K(t);
  return n || console.warn("No decoded token found"), n;
}, F = async (e = "accessToken") => k(e), ee = async (e, r = "accessToken") => {
  const t = await F(r);
  return t ? {
    name: e,
    value: t[e]
  } : null;
}, he = async () => {
  const e = await k();
  return e ? e.org_code || e["x-hasura-org-code"] : null;
}, ge = async (e = a.accessToken) => {
  const r = _();
  if (!r)
    return null;
  const t = await r.getSessionItem(
    e === "accessToken" ? a.accessToken : a.idToken
  );
  return t || null;
}, me = async (e) => {
  const r = await k();
  if (!r)
    return null;
  const t = r.feature_flags || r["x-hasura-feature-flags"];
  return t ? t[e]?.v ?? null : null;
}, ke = async () => {
  const e = await F("idToken");
  if (!e)
    return null;
  const { sub: r } = e;
  return r ? {
    id: e.sub,
    givenName: e.given_name,
    familyName: e.family_name,
    email: e.email,
    picture: e.picture
  } : (console.error("No sub in idToken"), null);
}, we = async (e) => {
  const r = await k();
  if (!r)
    return {
      permissionKey: e,
      orgCode: null,
      isGranted: !1
    };
  const t = r.permissions || [];
  return {
    permissionKey: e,
    orgCode: r.org_code,
    isGranted: !!t.includes(e)
  };
}, _e = async () => {
  const e = await k();
  if (!e)
    return {
      orgCode: null,
      permissions: []
    };
  const r = e.permissions || e["x-hasura-permissions"] || [];
  return {
    orgCode: e.org_code || e["x-hasura-org-code"],
    permissions: r
  };
}, Se = async () => {
  const e = await k("idToken");
  return e ? !e.org_codes && !e["x-hasura-org-codes"] ? (console.warn(
    "Org codes not found in token, ensure org codes have been included in the token customisation within the application settings"
  ), null) : e.org_codes || e["x-hasura-org-codes"] : null;
}, pe = async () => {
  const e = await k();
  return e ? !e.roles && !e["x-hasura-roles"] ? (console.warn(
    "No roles found in token, ensure roles have been included in the token customisation within the application settings"
  ), []) : e.roles || e["x-hasura-roles"] : [];
}, ye = async (e) => {
  try {
    const r = await k("accessToken");
    if (!r) return !1;
    if (!r.exp)
      return console.error("Token does not have an expiry"), !1;
    const t = r.exp < Math.floor(Date.now() / 1e3);
    return t && e?.useRefreshToken ? (await $({
      domain: e.domain,
      clientId: e.clientId
    })).success : !t;
  } catch (r) {
    return console.error("Error checking authentication:", r), !1;
  }
}, $ = async ({
  domain: e,
  clientId: r,
  refreshType: t = w.refreshToken,
  onRefresh: n
}) => {
  const o = (d) => (n && n(d), d);
  if (!e)
    return o({
      success: !1,
      error: "Domain is required for token refresh"
    });
  if (!r)
    return o({
      success: !1,
      error: "Client ID is required for token refresh"
    });
  let c = "", s;
  if (i.useInsecureForRefreshToken || !v(e) ? s = T() : s = _(), t === w.refreshToken) {
    if (!s)
      return o({
        success: !1,
        error: "No active storage found"
      });
    if (c = await s.getSessionItem(
      a.refreshToken
    ), !c)
      return o({
        success: !1,
        error: "No refresh token found"
      });
  }
  P();
  try {
    const d = await fetch(`${b(e)}/oauth2/token`, {
      method: "POST",
      ...t === w.cookie && { credentials: "include" },
      headers: {
        "Content-type": "application/x-www-form-urlencoded; charset=UTF-8"
      },
      body: new URLSearchParams({
        ...t === w.refreshToken && {
          refresh_token: c
        },
        grant_type: "refresh_token",
        client_id: r
      }).toString()
    });
    if (!d.ok)
      return o({
        success: !1,
        error: "Failed to refresh token"
      });
    const l = await d.json();
    if (l.access_token) {
      const u = _();
      return u ? (V(l.expires_in, async () => {
        $({ domain: e, clientId: r, refreshType: t, onRefresh: n });
      }), s && (await u.setSessionItem(
        a.accessToken,
        l.access_token
      ), l.id_token && await u.setSessionItem(a.idToken, l.id_token), l.refresh_token && await s.setSessionItem(
        a.refreshToken,
        l.refresh_token
      )), o({
        success: !0,
        [a.accessToken]: l.access_token,
        [a.idToken]: l.id_token,
        [a.refreshToken]: l.refresh_token
      })) : o({
        success: !1,
        error: "No active storage found"
      });
    }
  } catch (d) {
    return o({
      success: !1,
      error: `No access token received: ${d}`
    });
  }
  return o({
    success: !1,
    error: "No access token received"
  });
};
async function re(e) {
  const r = _();
  if (!r)
    throw new Error("No active storage found.");
  const t = await r.getSessionItem(a.accessToken);
  if (!t)
    throw new Error("Authentication token not found.");
  const n = await ee("iss");
  if (!n?.value)
    throw new Error("Domain (iss claim) not found.");
  let o;
  try {
    o = await fetch(`${n.value}/${e}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${t}`,
        "Content-Type": "application/json"
      }
    });
  } catch (s) {
    throw new Error(`Failed to fetch from ${n.value}/${e}: ${s}`);
  }
  if (!o.ok)
    throw new Error(`API request failed with status ${o.status}`);
  return await o.json();
}
const ve = async () => {
  const e = await re(
    "account_api/v1/entitlements"
  );
  return {
    orgCode: e.data.org_code,
    plans: e.data.plans.map((r) => ({
      key: r.key,
      subscribedOn: r.subscribed_on
    })),
    entitlements: e.data.entitlements.map((r) => ({
      id: r.id,
      fixedCharge: r.fixed_charge,
      priceName: r.price_name,
      unitAmount: r.unit_amount,
      featureKey: r.feature_key,
      featureName: r.feature_name,
      entitlementLimitMax: r.entitlement_limit_max,
      entitlementLimitMin: r.entitlement_limit_min
    }))
  };
}, g = {
  secure: null,
  insecure: null
}, $e = (e) => {
  g.secure = e;
}, _ = () => g.secure || null, Te = () => g.secure !== null, xe = () => {
  g.secure = null;
}, Ie = (e) => {
  g.insecure = e;
}, T = () => g.insecure || g.secure || null, Ce = () => g.insecure !== null, Ue = () => {
  g.insecure = null;
}, be = async (e) => (console.warn(
  "Warning: generateProfileUrl is deprecated. Please use generatePortalUrl instead."
), ne({
  domain: e.domain,
  returnUrl: e.returnUrl,
  subNav: e.subNav
}));
function te(e, r = []) {
  try {
    const t = new URL(e);
    return !r.includes(t.protocol) && !!t.host;
  } catch {
    return !1;
  }
}
const ne = async ({
  domain: e,
  returnUrl: r,
  subNav: t
}) => {
  const n = _();
  if (!n)
    throw new Error("generatePortalUrl: Active storage not found");
  const o = await n.getSessionItem(
    a.accessToken
  );
  if (!o)
    throw new Error("generatePortalUrl: Access Token not found");
  if (!te(r, ["ftp:", "ws:"]))
    throw new Error("generatePortalUrl: returnUrl must be an absolute URL");
  const c = new URLSearchParams({
    sub_nav: t || M.profile,
    return_url: r
  }), s = await fetch(
    `${b(e)}/account_api/v1/portal_link?${c.toString()}`,
    {
      headers: {
        Authorization: `Bearer ${o}`
      }
    }
  );
  if (!s.ok)
    throw new Error(
      `Failed to fetch profile URL: ${s.status} ${s.statusText}`
    );
  const d = await s.json();
  if (!d.url || typeof d.url != "string")
    throw new Error("Invalid URL received from API");
  try {
    return {
      url: new URL(d.url)
    };
  } catch (l) {
    throw console.error(l), new Error(`Invalid URL format received from API: ${d.url}`);
  }
}, Pe = {
  __esModule: !0,
  default: async () => (await import(
    /* webpackIgnore: true */
    "./expoSecureStore-BIzc_yrC.js"
  )).ExpoSecureStore
};
export {
  ve as A,
  _e as B,
  Se as C,
  pe as D,
  Pe as E,
  ye as F,
  $ as G,
  $e as H,
  _ as I,
  Te as J,
  xe as K,
  Ie as L,
  T as M,
  Ce as N,
  Ue as O,
  ue as P,
  de as Q,
  fe as R,
  E as S,
  B as T,
  D as U,
  M as V,
  H as W,
  I as X,
  w as Y,
  a,
  i as b,
  L as c,
  b as d,
  ae as e,
  ie as f,
  C as g,
  ce as h,
  le as i,
  v as j,
  V as k,
  P as l,
  W as m,
  p as n,
  be as o,
  ne as p,
  X as q,
  ee as r,
  A as s,
  F as t,
  he as u,
  ge as v,
  k as w,
  me as x,
  ke as y,
  we as z
};
